import { createSelector } from 'reselect'
import { StateWithAppNavigation } from '../types'
import { StyleState } from './types'

// Base selector for the style sub-slice
export const selectStyle = (state: StateWithAppNavigation): StyleState =>
  state.appNavigation.style

// Memoized selectors using createSelector for better performance
export const selectStyleSettings = createSelector(
  [selectStyle],
  style => style.settings
)

export const selectStyleIsLoading = createSelector(
  [selectStyle],
  style => style.isLoading
)

export const selectStyleHasChanges = createSelector(
  [selectStyle],
  style => style.hasChanges
)

// Memoized selectors for specific components using createSelector
export const selectStylePlacement = createSelector(
  [selectStyleSettings, selectStyleHasChanges],
  (settings, hasChanges) => ({
    placement: settings.placement,
    hasChanges,
  })
)

export const selectStyleSection = createSelector(
  [selectStyleSettings, selectStyleHasChanges],
  (settings, hasChanges) => ({
    backgroundColor: settings.backgroundColor,
    defaultLabelColor: settings.defaultLabelColor,
    selectedLabelColor: settings.selectedLabelColor,
    hasChanges,
  })
)
